import React, { useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Information from "../../Components/Information";
import BalanceViewSixy from "./BalanceViewSixy";
import BalanceTopUpViewSixy from "./BalanceTopUpViewSixy";
import { UserContext } from "../../User/UserContext";
import { useToast } from "../../Components/Toast/ToastContext";
import { ToastType } from "../../Components/Toast/Toast";

import styles from "./DonationView.module.css";
import balanceStyles from "./BalanceView.module.css";
import { PackageView } from "./PackageView";

export const DonationView = () => {
  const { user } = useContext(UserContext);
  const { showToast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const [showTopUpModal, setShowTopUpModal] = useState(false);
  const [conversionRates] = useState({ USD: 1.27, EUR: 1.17, GBP: 1 });

  const handleAddCreditsClick = () => {
    if (!user) {
      showToast(ToastType.Error, "Please login to add credits.", 3);
      navigate("/login", { state: { from: location.pathname } });
    } else {
      setShowTopUpModal(true);
    }
  };

  return (
    <div className={`card ${styles.wrapper}`}>
      <h2 className={styles.pageTitle}>Donations</h2>
      <p className={styles.pageSubtitle}>
        All donations go towards hosting and server costs. Your support is greatly appreciated!
      </p>
      <div className={styles.topRow}>
        <Information title="Balance">
          <BalanceViewSixy />
        </Information>
      </div>
      <div className={styles.ctaSection}>
        <button
          className={balanceStyles.addCreditsButton}
          onClick={handleAddCreditsClick}
        >
          Add Credits
        </button>
      </div>
      {showTopUpModal && (
        <BalanceTopUpViewSixy
          onClose={() => setShowTopUpModal(false)}
          conversionRates={conversionRates}
        />
      )}
      <Information title="Packages">
        <PackageView />
      </Information>
    </div>
  );
};
